import { fetchV3 } from "./client";

export const requestAuthCode = (body) =>
  fetchV3(
    {
      method: "POST",
      url: "auth/code/request/",
      body,
      useLoading: true,
      noToken: true,
    },
    false,
  );

export const validateAuthCode = (body) =>
  fetchV3(
    {
      method: "POST",
      url: "auth/code/validate/",
      body,
      useLoading: true,
      noToken: true,
    },
    false,
  );

export const refreshAuthToken = (refresh) =>
  fetchV3({
    method: "POST",
    url: "auth/token/refresh/",
    body: { refresh },
    useLoading: false,
  });
